const TMS = () => {
  return <h2>Coming Soon...</h2>;
};

export default TMS;
